import { styled, Typography } from "@mui/material";
import { useAppDispatch } from "../../../store/hook/store.hook";
import { Project as ProjectType } from "../../../store/schemas/project.schema";
import Project from "../../moleculas/projects/project";
import ViewerTemplate from "../plantillas/viewerTemplate";
import { FC, useEffect } from "react";
import { loadSelectedProject } from "../../../store/slices/project.slice";

const PreviewWrap = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  padding: "20px",
}));

const ContentWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "1200px",
  gap: "20px",
}));

const Section = styled("div")(() => ({
  flex: 1,
  padding: "1px",
  height: "400px", 
  overflow: "hidden", 
  display: "flex",
  flexDirection: "column",
}));

const ScrollableSection = styled(Section)(() => ({
  overflowY: "auto", 
  borderLeft: "1px solid #ddd", 
  paddingLeft: "20px",
}));

interface IPreviewProjectFormProps {
  project: ProjectType;
}

const PreviewProjectForm: FC<IPreviewProjectFormProps> = ({ project }) => {
  const dispatch = useAppDispatch();
  let tmpProject: ProjectType = project;

  useEffect(() => {
    dispatch(loadSelectedProject(tmpProject));
  }, []);

  return (
    <PreviewWrap>
      <ContentWrapper>
        <Section>
          <Typography variant="h5" gutterBottom>
            Información del proyecto
          </Typography>
          <Project project={tmpProject} />
        </Section>

        <ScrollableSection>
          <Typography variant="h5" gutterBottom>
            Información de la plantilla
          </Typography>
          <ViewerTemplate />
        </ScrollableSection>
      </ContentWrapper>
    </PreviewWrap>
  );
};

export default PreviewProjectForm;
